import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { QrCode } from "lucide-react";
import { LANGUAGES, LanguageCode } from "@/lib/i18n/translations";
import { Label } from "@/components/ui/label";

interface HeaderProps {
  language: LanguageCode;
  onLanguageChange: (language: LanguageCode) => void;
}

export function Header({ language, onLanguageChange }: HeaderProps) {
  return (
    <header className="border-b-2 bg-background">
      <div className="mx-auto flex h-16 w-full max-w-[1480px] items-stretch justify-between px-3 sm:h-20 sm:px-6">
        <div className="flex items-center gap-3 sm:gap-4">
          <div className="grid size-10 place-items-center border-2 bg-primary text-primary-foreground sm:size-12">
            <QrCode className="size-6 sm:size-7" strokeWidth={2.5} />
          </div>
          <div>
            <h1 className="text-xl font-black uppercase leading-none tracking-[-0.06em] sm:text-3xl">QR Forge</h1>
            <p className="mt-1 hidden font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-muted-foreground sm:block">
              Make it scannable
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3 border-l-2 pl-3 sm:pl-6">
          <Label htmlFor="language" className="hidden font-mono text-[10px] uppercase tracking-widest lg:block">Language</Label>
          <Select
            value={language}
            onValueChange={(value) => onLanguageChange(value as LanguageCode)}
          >
            <SelectTrigger id="language" aria-label="Language" className="w-[116px] bg-card sm:w-[160px]">
              <SelectValue placeholder="Language" />
            </SelectTrigger>
            <SelectContent align="end" className="min-w-[120px] sm:min-w-[150px]">
              {Object.entries(LANGUAGES).map(([code, name]) => (
                <SelectItem key={code} value={code}>
                  {name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </header>
  );
}
